/* eslint-disable */
'use client';

import { Cart } from '../../../interface/checkoutInterface';
import { RawEvent } from '../../../interface/eventInterface';
import { Tracker } from '../trackers';
import { v4 as uuidv4 } from 'uuid';

declare var snaptr: any;

export class SnapPixelTracker implements Tracker {
  private pixelIDs: string[];

  constructor(pixelIDs: string[]) {
    if (pixelIDs.length === 0) {
      throw new Error('SnapPixelTracker requires at least one pixel ID.');
    }
    this.pixelIDs = pixelIDs;
  }

  Init(): void {
    this.initializePixels();
  }

  private initializePixels() {
    (function (e: any, t: any) {
      if (e.snaptr) return;
      var a: any = (e.snaptr = function () {
        a.handleRequest
          ? a.handleRequest.apply(a, arguments)
          : a.queue.push(arguments);
      });
      a.queue = [];
      var s = 'script';
      var r: any = t.createElement(s);
      r.async = true;
      r.src = 'https://sc-static.net/scevent.min.js';
      var u: any = t.getElementsByTagName(s)[0];
      u.parentNode.insertBefore(r, u);
    })(window, document);

    this.pixelIDs.forEach(pixelID => {
      snaptr('init', pixelID);
    });
  }

  TrackEvent(event: RawEvent): void {
    this.pixelIDs.forEach(pixelID => {
      try {
        const cart: Cart | undefined = event?.cart;

        const initParams: Record<string, string> = {};
        if (cart?.Email) {
          initParams.user_email = cart.Email;
        }
        if (cart?.PhoneNumber) {
          initParams.user_phone_number = cart.PhoneNumber;
        }

        snaptr('init', pixelID, initParams);

        // Track the event
        switch (event.eventName) {
          case 'Purchase':
            if (cart) {
              this.handlePurchase(cart, event.orderId || '', event.status || 0);
            }
            break;
          case 'PageView':
            snaptr('track', 'PAGE_VIEW', {
              pixel_id: pixelID,
              description: 'Page Viewed',
            });
            break;
          case 'InitiateCheckout':
            snaptr('track', 'START_CHECKOUT', {
              pixel_id: pixelID,
              description: 'Checkout Started',
            });
            break;
          default:
            snaptr('track', event.eventName, { pixel_id: pixelID });
            break;
        }
      } catch (error) {
        console.error('Error tracking event:', error);
      }
    });
  }

  private handlePurchase(cart: Cart, orderId: string, status: number): void {
    console.log(cart, 'cart');
    const transformedEvent = {
      currency: cart.currencyCode || 'USD',
      price: parseFloat(cart.TotalAmount) || 0,
      transaction_id: orderId, // Use the provided orderId as the transaction_id
      first_name: cart?.ShippingAddress?.FirstName,
      last_name: cart?.ShippingAddress?.LastName,
      address1: cart?.ShippingAddress?.Address1,
      address2: cart?.ShippingAddress?.Address2,
      geo_city: cart?.ShippingAddress?.City,
      geo_country: cart?.ShippingAddress?.CountryCode,
      geo_region: cart?.ShippingAddress?.ProvinceCode,
      geo_postal_code: cart?.ShippingAddress?.Zip,
      success: status == 200 ? 1 : 0,
      client_dedup_id: uuidv4(),
      description: 'Purchase Completed',
      item_ids: cart.LineItems?.map(item => item.ProductID) || [],
    };

    console.log('Tracked PURCHASE event:', transformedEvent);
    // Track the PURCHASE event for this specific pixel ID
    this.pixelIDs.forEach(pixelID => {
      snaptr('track', 'PURCHASE', { ...transformedEvent, pixel_id: pixelID });
    });
  }
}
